<template>
  <div class="card-block" style="position:relative; top: 100px" @keypress.enter="validateAndSignInWithMFA">
    <h2>{{$lang.Login.TitleForm}}</h2>
    <p class="text-muted">{{$lang.Login.TitleFormDescription}}</p>
    <div class="input-group mb-3">
      <span class="input-group-addon"><i class="icon-user"></i></span>
      <b-form-input type="text"
              id="authCode"
              name="authCode"
              v-model="authCode"
              v-validate="'required'"
              :placeholder="errorsVee.has('authCode') ? errorsVee.first('authCode') : $lang.Login.authCode"
              :state="errorsVee.has('authCode') ? false : getValidationState('authCode')">
      </b-form-input>
    </div>
    <div class="row">
      <div class="col-6 text-left">
        <router-link :to="{ name: 'LostPassword' }" class="btn btn-link px-0 d-none">{{$lang.Login.LostPassowrd}}</router-link>
      </div>
      <div class="col-6 text-right">
        <button type="button" class="btn btn-third px-4" @click="validateAndSignInWithMFA"><i class="fas fa-sign-in-alt"></i> {{$lang.Login.ButtonEnter}}</button>
      </div>
    </div>
  </div>
</template>

<script>

import MfaScreen from './mfa.js'

export default MfaScreen

</script>



// WEBPACK FOOTER //
// src/views/public/auth/mfa/mfa.vue